import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import Documents from '../../../../../components/ui/Documents/Documents';
import { texts } from '../../../../../constants/texts';
import { getQueryKeys } from '../../../../../queries/queryKeys';
import useHouseAttachments from '../../../../../queries/useHouseAttachments';
import getHouseAttachment from '../../../../../requests/getHouseAttachment';
import { getBlobUrl } from '../../../../../../../helpers/getBlobUrl';
import { docEntities } from '../../../../../constants/common';
import useChangeDocModalVisible from '../../../../../hooks/useChangeDocModalVisible';
import { useDeleteDocMutation } from '../../../../../mutations/useDocMutations';

const HouseDocuments = () => {
  const params = useParams();

  const { openModal: openDocFormModal } = useChangeDocModalVisible();

  const houseId = Number(params.pageId);

  const houseAttachmentsKeys = getQueryKeys.houseAttachments(houseId);

  const defaultDocData = {
    entity: docEntities.house,
    params: { id: houseId, keys: houseAttachmentsKeys },
    typeId: 1, //Общий
  };

  const { mutate: deleteDoc, isLoading: isDeleteDocLoading } =
    useDeleteDocMutation(defaultDocData);

  const { data: docs, isFetching: isDocsFetching } = useHouseAttachments(
    houseId,
    { staleTime: Infinity }
  );

  const getAttachmentUrl = async (data) => {
    const fileName = typeof data === 'string' ? data : data.fileName;

    const fileExtension = fileName.split('.')[1];

    const attachment = await getHouseAttachment(houseId, fileName);

    const url = getBlobUrl(attachment, fileExtension);

    return url;
  };

  const docsSorted = useMemo(() => {
    return docs?.sort((a, b) => b.createDate.localeCompare(a.createDate)) || [];
  }, [docs]);

  return (
    <Documents
      docs={docsSorted}
      title={texts.homeDocuments}
      loading={isDocsFetching || isDeleteDocLoading}
      getAttachmentUrl={getAttachmentUrl}
      onDeleteDocument={deleteDoc}
      onAddBtnClick={() => openDocFormModal(defaultDocData)}
      onEditClick={(attachment) =>
        openDocFormModal({ ...defaultDocData, attachment })
      }
    />
  );
};

export default HouseDocuments;
